module.exports = remoteOneStyle2;